import Collapse from 'src/shared/ui/Collapse/Collapse';
import styled from 'styled-components';

export const HowItWorksCollapse = styled(Collapse)`
  margin-bottom: 16px;
`;
